
var wFlag = window.innerWidth>750

$(() => {
    setTimeout(() => {
        $('.box1_img img:last-child').css({opacity:1})
    }, 1000);

    //box2
    var $content = $(".marquee-content");
    var html = $content.html();

    // 复制一份，实现无缝滚动
    $content.append(html);
    var width = $content.children().eq(0).outerWidth(true);
    var left = 0;
    function move() {
        left--;
        if (-left >= width) {
            left = 0;
        }
        $content.css("transform", "translateX(" + left + "px)");
    }
    if(!wFlag){
        setInterval(move, 20); // 数值越小速度越快
    }

    gsap.registerPlugin(SplitText,ScrollTrigger)
    //box3
    SplitText.create(".box3_title", {
        type: "words", //words
        autoSplit: true,
        onSplit(self) {
            return gsap.from(self.words, {
                y: 30,
                opacity: 0,
                //duration: 0.7, 
                ease: "power4",
                stagger: 0.1,
                scrollTrigger:{
                    trigger:'.box3',
                    start:wFlag?'top top+=10%':'top top+=30%',
                    end:wFlag?'+=60%':'+=40%',
                    scrub:1
                }
            });
        }
    });
    ScrollTrigger.create({
        trigger:'.box3',
        start:wFlag?'top+=25% top':'top top',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from(".box3_bag",{scale:0,duration:.12,ease:"power2.out"})
            .fromTo(".box3_bag img",{y:'105%',scaleX:.96,scaleY:.96},{y:0,duration:.62,ease:"power3.out"})
            .to(".box3_bag img",{y:'10%',scaleX:1.04,scaleY:.96,duration:.12,ease:"power1.in"})
            .to(".box3_bag img",{ y:0,scaleX:1,scaleY:1,duration:.28,ease:"elastic.out(1,.45)"})
            .to(".box3_bag p",{scaleX:1.12,duration:.12,ease:"power2.out"},.38)
            .to(".box3_bag p",{scaleX:1,duration:.28,ease:"elastic.out(1,.5)"},.5)
    })
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top+=27% top',
            end:'+=160%',
            pin:true,
            scrub:1,
            animation:gsap.timeline()
                .to({},{duration:0.2})
                .to(".box3_bg",{scale:1.5})
                .from(".box4",{opacity:0,duration:0.3})
                .from(".box4_items",{opacity:0,y:'72%'})
                .to(".box4_item div",{x:0,opacity:1},'<')
                .from(".box4_text",{opacity:0})
                .to({},{duration:0.2})
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top+=5% top',
            end:'+=160%',
            pin:true,
            scrub:1,
            animation:gsap.timeline()
                .to({},{duration:0.2})
                .to(".box3_bg",{scale:1.2})
                .from(".box4",{opacity:0,duration:0.3})
                .from(".box4_items",{opacity:0})
                .to(".box4_item",{x:'-43%'})
                .to({},{duration:0.2})
        })
    }

    //box5
    const cards = [...document.querySelectorAll('.box5_card')];

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.box5',
            start: wFlag?'top top+=2%':'top top+=8%',
            end: () => `+=${innerHeight * 3}`, // 4 张图共需要 3 次切换
            pin: true,
            scrub: .7,
            invalidateOnRefresh: true
        }
    });

    gsap.from(cards[0], { opacity: 0, duration: 1, scrollTrigger: { trigger: '.box5', start: 'top center', toggleActions:'play none none reverse' } });

    // 后一张从底部叠上来；越靠后的旧图缩得越小，形成明显层级
    cards.slice(1).forEach((card, i) => {
        const n = i + 1;

        // 当前图片上来时，重新计算它前面所有图片的缩放比例
        cards.slice(0, n).forEach((old, j) => {
            const depth = n - j; // 距离当前图越远，depth 越大
            tl.to(old, {
                scale: 1 - depth * .05, // 0.975 → 0.95 → 0.925
                duration: 1
            }, i);
        });

        tl.to(card, { y: 0, duration: 1 }, i);
    });

    tl.to(cards[3], { scale:1.05,borderRadius:0 })
    .to('.box5_title', { opacity:1 },'<')
    

    //box6
    const strokes = [...document.querySelectorAll(".write-stroke")].sort((a, b) => +a.id.split("-")[1] - +b.id.split("-")[1]);
    strokes.forEach(path => {
        const len = path.getTotalLength();
        path.style.strokeDasharray = len;
        path.style.strokeDashoffset = len;
    });
    const box6tl = gsap.timeline({ defaults: { ease: "none" }, scrollTrigger: { trigger: '.box6', start: 'top center'} });
    strokes.forEach(path => {
        const len = path.getTotalLength();
        const gap = +(path.dataset.gap || 0);

        if (gap) box6tl.to({}, { duration: gap });

        box6tl.to(path, {
            strokeDashoffset: 0,
            duration: Math.max(.22, len / 620)
        });
    });
    // 动画倍速
    box6tl.timeScale(5);

    
    SplitText.create(".box6_item div:nth-child(4) p", {
        type: "chars", //words
        autoSplit: true,
        onSplit(self) {
            return gsap.from(self.chars, {
                opacity: 0,
                //duration: 0.7, 
                ease: "power4",
                stagger: 0.05,
                scrollTrigger:{
                    trigger:'.box6',
                    toggleActions: 'play none none reverse',
                    start:wFlag?'top top+=10%':'top top+=30%',
                    end:'+=0%',
                }
            });
        }
    });
    
    ScrollTrigger.create({
        trigger:'.box6',
        start:'top top+=10%',
        end:'+=0%',
        toggleActions: 'play none none reverse',
        animation:gsap.timeline()
            .from(".box6_item div:nth-child(1) img:last-child",{rotateY:360,duration:1})
    })

    // 序列帧Canvas
    const FRAME_COUNT = 49;
    const FRAME_BASE_URL = 'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/oxbot_box6_';
    const FRAME_SOURCES = Array.from(
        { length: FRAME_COUNT },
        (_, index) => `${FRAME_BASE_URL}${index + 1}.avif`
    );
    const canvas = document.querySelector('.box6_video');
    const ctx = canvas.getContext('2d', {
        alpha: false,
        desynchronized: true
    });
    const images = new Array(FRAME_COUNT);
    const loaded = new Uint8Array(FRAME_COUNT);
    let loadedCount = 0;
    let wantedFrame = 0;
    let drawnFrame = -1;
    let rafId = 0;

    // 限制 DPR，避免 Retina 屏下 Canvas 像素量过大。
    const getDpr = () => Math.min(window.devicePixelRatio || 1, 2);
    function resizeCanvas() {
        const rect = canvas.getBoundingClientRect();
        const dpr = getDpr();

        const width = Math.max(1, Math.round(rect.width * dpr));
        const height = Math.max(1, Math.round(rect.height * dpr));

        if (canvas.width !== width || canvas.height !== height) {
            canvas.width = width;
            canvas.height = height;
            drawnFrame = -1;
            requestDraw(wantedFrame);
        }
    }
    function drawImageContain(img) {
        // 源图是竖版；这里使用 contain，保证人物完整显示
        const cw = canvas.width;
        const ch = canvas.height;
        const iw = img.naturalWidth || img.width;
        const ih = img.naturalHeight || img.height;

        if (!cw || !ch || !iw || !ih) return;

        const scale = Math.min(cw / iw, ch / ih);
        const dw = iw * scale;
        const dh = ih * scale;
        const dx = (cw - dw) * 0.5;
        const dy = (ch - dh) * 0.5;

        ctx.clearRect(0, 0, cw, ch);
        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, cw, ch);
        ctx.drawImage(img, dx, dy, dw, dh);
    }
    function findNearestLoaded(index) {
        if (loaded[index]) return index;

        for (let offset = 1; offset < FRAME_COUNT; offset++) {
            const before = index - offset;
            const after = index + offset;

            if (before >= 0 && loaded[before]) return before;
            if (after < FRAME_COUNT && loaded[after]) return after;
        }

        return -1;
    }
    function drawNow() {
        rafId = 0;

        const index = findNearestLoaded(wantedFrame);
        if (index < 0 || index === drawnFrame) return;

        const img = images[index];
        if (!img || !img.complete) return;

        drawImageContain(img);
        drawnFrame = index;
    }
    function requestDraw(index) {
        wantedFrame = Math.max(0, Math.min(FRAME_COUNT - 1, Math.round(index)));

        if (!rafId) {
            // 合并到浏览器下一次 requestAnimationFrame。 每个屏幕刷新周期最多绘制一次
            rafId = requestAnimationFrame(drawNow);
        }
    }
    function loadFrame(index) {
        if (images[index]) return;

        const img = new Image();
        img.decoding = 'async';

        img.onload = () => {
            loaded[index] = 1;
            loadedCount++;

            if (index === 0 && drawnFrame < 0) {
                resizeCanvas();
                requestDraw(0);
            }

            // 当前目标帧刚加载完成，立即请求下一次绘制。
            if (index === wantedFrame) {
                drawnFrame = -1;
                requestDraw(index);
            }
        };

        img.onerror = () => {
            console.warn('序列帧加载失败：', index);
        };

        img.src = FRAME_SOURCES[index];
        images[index] = img;
    }
    function preloadFrames() {
        // 首批优先加载前 10 帧。
        for (let i = 0; i < Math.min(10, FRAME_COUNT); i++) {
            loadFrame(i);
        }

        let next = 10;

        const loadRest = deadline => {
            while (
                next < FRAME_COUNT &&
                (!deadline || deadline.timeRemaining() > 4)
            ) {
                loadFrame(next++);
            }

            if (next < FRAME_COUNT) {
                if ('requestIdleCallback' in window) {
                    requestIdleCallback(loadRest, { timeout: 500 });
                } else {
                    setTimeout(() => loadRest(null), 16);
                }
            }
        };

        if ('requestIdleCallback' in window) {
            requestIdleCallback(loadRest, { timeout: 500 });
        } else {
            setTimeout(() => loadRest(null), 16);
        }
    }
    function initScrollAnimation() {
        if (!window.gsap || !window.ScrollTrigger) {
            console.error('GSAP 或 ScrollTrigger 未加载。');
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        const playhead = { frame: 0 };

        const tl = gsap.timeline({defaults: { ease: 'none' }});

        tl.to(canvas, {
                xPercent: wFlag?17.5:14.5,
                yPercent: wFlag?22:60,
                scale: 0.08,
                duration: 0.5,
                force3D: true
            })
            .to({}, { duration: 0.2 });

        /* 图片序列从第 0 帧走到第 48 帧， 与整个 timeline 同步。 */
        tl.to(playhead, {
            frame: FRAME_COUNT - 1,
            duration: tl.duration(),
            ease: 'none',
            onUpdate: () => requestDraw(playhead.frame)
        }, 0);

        scrollTrigger = ScrollTrigger.create({
            trigger: '.box6',
            start:'top+=20% top',
            end: wFlag?'+=60%':'+=40%',
            scrub: 0.2,
            animation: tl,
            onRefresh: resizeCanvas
        });

        // 确保初始帧正确。
        requestDraw(0);
    }
    // 初始化
    resizeCanvas();
    preloadFrames();
    initScrollAnimation();


    //打字效果
    const lines = gsap.utils.toArray(".type-line");
    function initTyping() {
        const items = lines.map((line) => {
            // 先记录完整文字宽度，避免逐字显示时整行因为居中而左右漂移
            const fullWidth = line.getBoundingClientRect().width;
            line.style.width = `${fullWidth}px`;

            const split = new SplitText(line, {
                type: "chars",
                charsClass: "char"
            });

            const cursor = document.createElement("span");
            cursor.className = "cursor";
            cursor.setAttribute("aria-hidden", "true");
            line.appendChild(cursor);

            gsap.set(split.chars, {
                display: "none",
                opacity: 0,
                y: 8
            });

            return {
                line,
                chars: split.chars,
                cursor
            };
        });

        // 光标闪烁
        gsap.to(".cursor", {
            opacity: 0,
            duration: 0.42,
            repeat: -1,
            yoyo: true,
            ease: "steps(1)"
        });

        const tl = gsap.timeline({delay: 0.45,scrollTrigger: { trigger: '.box6', start: wFlag?'top+=20% top':'top+=30% top'} });

        items.forEach((item, index) => {
            tl.set(item.cursor, {
                display: "inline-block",
                opacity: 1
            });

            item.chars.forEach((char) => {
                tl.set(char, {
                    display: "inline-block"
                });

                tl.to(char, {
                    opacity: 1,
                    y: 0,
                    duration: 0.055,
                    ease: "power2.out"
                });

                // 轻微随机化节奏，让打字不像机械等间隔
                tl.to({}, {
                    duration: gsap.utils.random(0.025, 0.075)
                });
            });

            tl.to({}, {
                duration: 0.2
            });

            if (index !== items.length - 1) {
                tl.set(item.cursor, {
                    display: "none"
                });
            }
        });
    }
    // 等字体布局稳定后再计算宽度
    window.addEventListener("load", initTyping);

    //box7
    const goodDrawPaths = [...document.querySelectorAll(".good-draw-path")]
        .sort((firstPath, secondPath) => +firstPath.id.split("-").at(-1) - +secondPath.id.split("-").at(-1));

    goodDrawPaths.forEach(drawPath => {
        const pathLength = drawPath.getTotalLength();
        drawPath.style.strokeDasharray = pathLength;
        drawPath.style.strokeDashoffset = pathLength;
    });

    const goodDrawTimeline = gsap.timeline({
        defaults: { ease: "none" },
        scrollTrigger: { trigger: ".box7", start: wFlag?"top top+=20%":"top top+=10%" }
    });

    goodDrawPaths.forEach(drawPath => {
        const pathLength = drawPath.getTotalLength();
        const strokeDelay = +(drawPath.dataset.gap || 0);

        if (strokeDelay) goodDrawTimeline.to({}, { duration: strokeDelay });

        goodDrawTimeline.to(drawPath, {
            strokeDashoffset: 0,
            duration: Math.max(.22, pathLength / 620)
        });
    });
    goodDrawTimeline.to('.box7_title span',{opacity:0})

    // 动画倍速
    goodDrawTimeline.timeScale(3);

    // 漫画
    ScrollTrigger.create({
        trigger: '.box7',
        start: wFlag?'top bottom':'top bottom-=20%',
        end: wFlag?'+=100%':'+=70%',
        scrub:1,
        animation: gsap.timeline()
            .to('.box7_img', { x:wFlag?'-48%':'-71%',y:wFlag?'-72%':'-110%' })
    })

    //box8
    const nextV4Tracks = [...document.querySelectorAll('.next-v4-track')]
        .sort((firstTrack, secondTrack) => {
            const firstOrder = Number(firstTrack.id.split('-').pop());
            const secondOrder = Number(secondTrack.id.split('-').pop());
            return firstOrder - secondOrder;
        });

    nextV4Tracks.forEach(currentTrack => {
        const currentLength = currentTrack.getTotalLength();
        currentTrack.style.strokeDasharray = currentLength;
        currentTrack.style.strokeDashoffset = currentLength;
    });

    const nextV4Timeline = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
            trigger: '.box8',
            start: 'top top+=20%'
        }
    });

    nextV4Tracks.forEach(currentTrack => {
        const currentLength = currentTrack.getTotalLength();
        const currentGap = Number(currentTrack.dataset.gap || 0);
        const isDetailTrack = currentTrack.classList.contains('next-v4-detail');
        const currentIndex = Number(currentTrack.id.split('-').pop());

        if (currentGap) {
            nextV4Timeline.to({}, { duration: currentGap });
        }

        nextV4Timeline.to(currentTrack, {
            strokeDashoffset: 0,
            duration: isDetailTrack
                ? Math.max(0.08, currentLength / 1150)
                : Math.max(0.22, currentLength / 620)
        });

        // 对应字母完成时，把中心线没有覆盖到的原 SVG 细节平滑补齐。
        if (currentIndex === 2) {
            nextV4Timeline.to('#next-v4-complete-n', { opacity: 1, duration: 0.045 });
        }
        if (currentIndex === 6) {
            nextV4Timeline.to('#next-v4-complete-e', { opacity: 1, duration: 0.045 });
        }
        if (currentIndex === 10) {
            nextV4Timeline.to('#next-v4-complete-x', { opacity: 1, duration: 0.045 });
        }
        if (currentIndex === 12) {
            nextV4Timeline.to('#next-v4-complete-t', { opacity: 1, duration: 0.045 });
        }
    });

    // 最后一帧一定回到完整原图，彻底避免任何毛边、飞白或分离笔画被 mask 遗漏。
    nextV4Timeline.to('#next-v4-final-source', {
        opacity: 1,
        duration: 0.035
    });

    nextV4Timeline.to('.box8_title span',{opacity:0})

    // 动画倍速
    nextV4Timeline.timeScale(5);
    
    ScrollTrigger.create({
        trigger:'.box8',
        start:wFlag?'top top+=6%':'top top+=11%',
        end:'+=50%',
        pin:true,
        scrub:1,
        animation:gsap.timeline()
            .to({},{duration:0.2})
            .to(".box8_bg",{clipPath:'inset(34% 0 34% 0)'})
            .to({},{duration:0.2})
    })
    
    ScrollTrigger.create({
        trigger:'.box9',
        start:wFlag?'top center-=10%':'top center',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box9_img',{rotateX:90})
    })

    //打字效果
    const lines2 = gsap.utils.toArray(".box9_text c");
    function initTyping2() {
        const items = lines2.map((line) => {
            // 先记录完整文字宽度，避免逐字显示时整行因为居中而左右漂移
            const fullWidth = line.getBoundingClientRect().width;
            line.style.width = `${fullWidth}px`;

            const split = new SplitText(line, {
                type: "chars",
                charsClass: "char"
            });

            const cursor = document.createElement("span");
            cursor.className = "cursor2";
            cursor.setAttribute("aria-hidden", "true");
            line.appendChild(cursor);

            gsap.set(split.chars, {
                display: "none",
                opacity: 0,
                y: 8
            });

            return {
                line,
                chars: split.chars,
                cursor
            };
        });

        // 光标闪烁
        gsap.to(".cursor2", {
            opacity: 0,
            duration: 0.42,
            repeat: -1,
            yoyo: true,
            ease: "steps(1)"
        });

        const tl = gsap.timeline({delay: 0.45,scrollTrigger: { trigger: '.box9', start:'top top+=30%'} });

        items.forEach((item, index) => {
            tl.set(item.cursor, {
                display: "inline-block",
                opacity: 1
            });

            item.chars.forEach((char) => {
                tl.set(char, {
                    display: "inline-block"
                });

                tl.to(char, {
                    opacity: 1,
                    y: 0,
                    duration: 0.055,
                    ease: "power2.out"
                });

                // 轻微随机化节奏，让打字不像机械等间隔
                tl.to({}, {
                    duration: gsap.utils.random(0.025, 0.075)
                });
            });

            if (index !== items.length - 1) {
                tl.set(item.cursor, {
                    display: "none"
                });
            }
        });

        tl.from('.box9_info', {opacity:0});
    }
    // 等字体布局稳定后再计算宽度
    window.addEventListener("load", initTyping2);
    
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box9',
            start:wFlag?'top top+=6%':'top top+=9%',
            end:'+=40%',
            pin:true
        })
    }
});
